import React from 'react'
import OtpForm from './OtpForm'

const OTP = () => {
    return (
        <div className='login min-h-screen 2xl:p-40 2xl:px-96 xl:p-40 flex justify-center items-center'>
            <OtpForm/>
        </div>
    )
}

export default OTP